import { alarmRulesState } from "../state/alarmRulesState";
import {
  Fetch_All_Region_Data1,
  Fetch_All_Alarm_Rules_Data,
  Update_Alarm_Rule_Success,
 Update_AddUpdateLifeguardPerformedDefibrillatorCpr_Success,
 Fetch_All_AddUpdateLifeguardPerformedDefibrillatorCpr_Data
} from "../action/alarmRulesAction";
export function AlarmRulesReducer(state = alarmRulesState, action) {
  switch (action.type) {
        case Fetch_All_AddUpdateLifeguardPerformedDefibrillatorCpr_Data:
      return Object.assign({}, state, {
        errorCode: action.errorCode,
        statusCode: action.statusCode,
        lifeguardPerformedDefibrillator: action.lifeguardPerformedDefibrillator,
      });
    case Update_AddUpdateLifeguardPerformedDefibrillatorCpr_Success:
      return Object.assign({}, state, {
        errorCode: action.errorCode,
        statusCode: action.statusCode,
        message: action.message,
        lifeguardPerformedDefibrillator: action.lifeguardPerformedDefibrillator,
      });

    case Fetch_All_Alarm_Rules_Data:
      return Object.assign({}, state, {
        errorCode: action.errorCode,
        statusCode: action.statusCode,
        alarmRules: action.alarmRules,
      });
    case Update_Alarm_Rule_Success:
      return Object.assign({}, state, {
        errorCode: action.errorCode,
        statusCode: action.statusCode,
        message: action.message,
        updatedList: action.list,
      });
    case Fetch_All_Region_Data1:
      return Object.assign({}, state, {
        errorCode: action.errorCode,
        statusCode: action.statusCode,
        regionList: action.regionList,
      });
    default:
      return state;
  }
}
